// A urbe.me não recebe mais novos cadastros de incorporador nem novos cálculos da
// calculadora de viabilidade: os dois funis passaram para o OSPA capital.
// O servidor também redireciona essas rotas (website/urls.py); estas constantes
// existem porque o vue-router navega no cliente e nunca chega a bater no Django.
export const OSPA_CAPITAL_BASE_URL = 'https://ospa.capital';

// Sem o ?ref= o /register do OSPA capital exige código de convite (validado no
// servidor deles). S319 é o parceiro "OSPAcapital/incorporador", o mesmo código
// usado pelos CTAs da landing oficial.
export const OSPA_CAPITAL_REFERRAL_CODE = 'S319';

export const OSPA_CAPITAL_LANDING_URL = `${OSPA_CAPITAL_BASE_URL}/home`;
export const OSPA_CAPITAL_CADASTRO_INCORPORADOR_URL = `${OSPA_CAPITAL_BASE_URL}/register?ref=${OSPA_CAPITAL_REFERRAL_CODE}`;
